import type { UserOrganizationWithRole } from '../types/organization.type';

export type OrgRole = UserOrganizationWithRole['role'];

const BILLING_MANAGER_ROLES: OrgRole[] = ['OWNER', 'ADMIN'];

/**
 * Pure check used by client components to gate UI affordances. Mirrors
 * {@link assertCanManageBilling} so the UI hides what the server would reject.
 */
export function canManageBilling(role: OrgRole | null | undefined): boolean {
	return !!role && BILLING_MANAGER_ROLES.includes(role);
}

/** @internal — exported for the server-side guard. */
export const _BILLING_MANAGER_ROLES = BILLING_MANAGER_ROLES;
